const outdoorLiving = [
  {
    question: "What is included in an outdoor living space project?",
    answer:
      "An outdoor living project<IN_CITY_ZIP> can include patios, pergolas, fire pits, built-in seating, outdoor kitchens, and lighting. Each space is custom-designed to match your layout, lifestyle, and budget.",
  },
  {
    question: "Do I need a permit for building an outdoor living area?",
    answer:
      "Yes. Most outdoor living projects<IN_CITY_ZIP> involving structures, electrical, or plumbing require permits. Modern Build handles all permitting and inspections to ensure code compliance.",
  },
  {
    question: "How long does it take to complete an outdoor living project?",
    answer:
      "Most projects take 2 to 6 weeks<IN_CITY_ZIP>, depending on scope, weather, and permitting timelines. We’ll provide a clear schedule during your consultation.",
  },
  {
    question: "Can outdoor living features increase my home value?",
    answer:
      "Yes. Patios, fire features, and outdoor kitchens<IN_CITY_ZIP> often boost resale value and curb appeal by adding functional outdoor space for relaxation and entertaining.",
  },
  {
    question: "What materials are used for patios and fire features?",
    answer:
      "We use high-quality materials including concrete pavers, natural stone, brick, composite decking, and stucco. Fire pits can be gas or wood-burning, built to suit your vision<IN_CITY_ZIP>.",
  },
  {
    question: "Is outdoor lighting included in your builds?",
    answer:
      "Yes. We include integrated lighting like path lights, sconces, pergola uplighting, and accent LEDs to enhance safety and ambiance<IN_CITY_ZIP>.",
  },
  {
    question: "Can you install utilities like gas, water, or electricity?",
    answer:
      "Absolutely. We coordinate with independent, licensed professionals in <IN_CITY_ZIP> to install underground gas, water, and electrical lines for outdoor kitchens, lighting, fire features, and more.",
  },
  {
    question: "Do you offer 3D design or renderings for outdoor projects?",
    answer:
      "Yes. We provide 3D design visuals and layout renderings<IN_CITY_ZIP> so you can visualize the final result before construction begins. This helps with planning, approvals, and material selections.",
  },
  {
    question: "How much does an outdoor living space cost?",
    answer:
      "Pricing varies based on design, materials, and features. A basic patio may start around $10,000<IN_CITY_ZIP>, while custom outdoor kitchens or lounges can exceed $50,000. We offer detailed, transparent estimates.",
  },
];

export default outdoorLiving;
